module.exports = __webpack_public_path__ + "img/Map.25f5c967.png";